export default {
	"scanPay.PaymentFailed": "支付失敗!",
	"scanPay.PaymentCancellation": "支付取消",
	"scanPay.networkAnomaly": "網絡異常",
	"scanPay.paymentSuccessful": "支付成功",
	"scanPay.PleaseUseWeChatOrAlipayToScanTheQRCodeToPay": "請使用微信或支付寶掃碼付款",
	"scanPay.TheOrderIsAbnormalPleaseTryAgainLater": "訂單異常，請稍後重試",
	"scanPay.PaymentAmount": "支付金額",
	"scanPay.toPay": "去支付"
}